import React, { useEffect, useRef, useState } from "react";
import personaServicio from "../../services/persona/personaServicio";
import { IPaginacion, Ifilter, InitialFilter } from "../../Interfaces/filter";
import { ISupervisores } from "../../Interfaces/IPersona";
import { ISearchBox } from "@fluentui/react";

export const useTableSupervisores = () => {
  const controllerAbort = useRef<AbortController>(new AbortController());
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState<Ifilter>(InitialFilter);
  const [dataTable, setDataTable] = useState<ISupervisores[]>([]);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const searchBoxRefTable = useRef<ISearchBox>(null);
  const _onkeyUpSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const getTableSupervisores = () => {
    setIsLoading(true);
    controllerAbort.current.abort();
    const newController = new AbortController();
    controllerAbort.current = newController;
    personaServicio
      .getSupervisores(filter, newController)
      .then((res) => {
        if (res.status === 200) {
          setDataTable(res.data.items);
          setIsLoading(false);
          setPaginacion({
            page: res.data.page,
            total: res.data.total,
            pages: res.data.pages,
          });
        }
      })
      .catch((e: Error) => {
        console.log(e.message);
        setIsLoading(false);
      });
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;
      default:
        break;
    }
  };

  const refreshTable = () => {
    getTableSupervisores();
  };


  useEffect(() => {
    getTableSupervisores();
  }, [filter]);

  return {
    paginacion,
    dataTable,
    isLoading,
    searchBoxRefTable,
    _onkeyUpSearch,
    onChangeSkip,
    refreshTable,
    filter,
    setFilter,
    getTableSupervisores
  };
};
